import firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/remote-config'
import { useEffect, useState } from 'react'

// https://firebase.google.com/docs/remote-config/get-started?platform=web#web
// --------------------------------------------------------------------------------
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DB,
  projectId: process.env.REACT_APP_FIREBASE_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORE,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MID
}

// Hook para ver si la verificacion de identidad Incode esta habilitada
export const useIncodeRemoteConfig = () => {
  const [incodeEnabled, setIsEnabled] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchIncodeConfig = async () => {
      // Inicializar Firebase solo si no está ya inicializado
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig)
      }
      
      const remoteConfig = firebase.remoteConfig()

      remoteConfig.settings.minimumFetchIntervalMillis = 60 * 10000
      remoteConfig.defaultConfig = {
        incode_enabled: false
      }

      try {
        await remoteConfig.fetchAndActivate()
        const val = remoteConfig.getValue('incode_enabled')
        setIsEnabled(val.asBoolean())
      } catch (error) {
        setIsEnabled(false)
      } finally {
        setIsLoading(false)
      }
    }

    fetchIncodeConfig()
  }, [])

  return { incodeEnabled, isLoading }
}
